import { isAvailable, Feature } from 'App/services/FeatureHelperStandalone';
export default function allowed() {
	return isAvailable(Feature.PROSPECTING_BASIC);
}
